<template>
  <div class="seach-shade" v-if="openFlag" @click="seachShadeClick">
    <div class="searchBox" @click.stop="searchBoxClick">
      <div class="search-input">
        <div class="input">
          <el-input placeholder="搜索关键词" v-model="searchStr" @change="searchChange" @keyup.enter.native="searchCLick" clearable>
            <el-button slot="append" icon="el-icon-search" @click="searchCLick"></el-button>
          </el-input>

        </div>
        <div class="keywords">
          <div class="key-text">
            <div class="label">热门标签</div>
            <el-checkbox-group v-model="keywordCheckList" @change="searchCLick">
                <el-checkbox v-for="(item,index) in keywordList" :label="item" :key="index"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "h-search",
  props:{
    openFlag:{
      default:false,
      type:Boolean,
    }
  },
  data(){
    return{
      searchStr:'',
      keywordList:[
          '日常',
          '编程',
      ],
      keywordCheckList:[]
    }
  },
  methods:{
    /**
     * 搜索框点击（遮罩层）
     */
    seachShadeClick(){
      this.$emit("close");
    },
    /**
     * 搜索框点击
     */
    searchBoxClick(){

    },
    /**
     * 搜索字符
     */
    searchCLick(){
      this.$emit("search",this.searchStr,this.keywordCheckList);
    },
    /**
     * 搜索字符变动
     */
    searchChange(){
      // this.$emit("search",this.searchStr);
      if(!this.searchStr){
        this.$emit("search",this.searchStr);
      }
    },
  }
}
</script>

<style scoped>

.seach-shade {
  /*position: fixed;*/
  /*top: 0;*/
  /*bottom: 0;*/
  /*z-index: -5;*/
  transition: all .5s;
  overflow: hidden;
  width: 100%;
}

.seach-shade .searchBox {
  padding: 32px 0;
  height: 178px;
  /*position: absolute;*/
  /*top: 60px;*/
  /*left: 0;*/
  /*right: 0;*/
  font-size: 14px;
  background: #fff;
}

.seach-shade .searchBox .search-input {
  margin: 0 auto;
  width: 810px;
  height: 114px;
}



.search-input .input {
  width: 810px;
  height: 60px;
  position: relative;
}

.search-input .input input {
  padding: 23px 15px 23px 18px;
  width: 810px;
  height: 60px;
  outline: none;
  border: 1px solid #e5e5e5;
}

.search-input .input .icon-sousuo {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translate3d(0, -50%, 0);
  font-size: 24px;
  color: #666;
}

.search-input .input .icon-sousuo:hover {
  cursor: pointer;
}

.search-input .keywords {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ;
  padding-right: 10px;
  width: 800px;
  height: 24px;
}

.search-input .keywords .label {
  margin-right: 20px;
  font-size: 16px;
  color: #655e5e;
}

.search-input .keywords .item {
  margin-right: 10px;
  padding: 0 12px;
  font-size: 12px;
  color: #8e8787;
}

.search-input .keywords .item:hover {
  cursor: pointer;
}

.search-input .keywords .change {
  position: relative;
  cursor: pointer;
  right: 0;
}

.search-input .key-text {
  display: flex;
  align-items: center;
}
</style>
